module.exports = __webpack_public_path__ + "img/Pencils.92045851.svg";